export interface PasswordValidationResult {
  isValid: boolean;
  errors: {
    password?: string;
    confirmPassword?: string;
  };
}

/**
 * Validates new password and password confirmation for password reset.
 */
export function validatePasswordReset(password: string, confirmPassword: string): PasswordValidationResult {
  const errors: { password?: string; confirmPassword?: string } = {};

  if (!password) {
    errors.password = "Password is required.";
  } else if (password.length < 6) {
    errors.password = "Password must be at least 6 characters long.";
  }

  if (!confirmPassword) {
    errors.confirmPassword = "Please confirm your new password.";
  } else if (password !== confirmPassword) {
    errors.confirmPassword = "Passwords do not match.";
  }

  return {
    isValid: Object.keys(errors).length === 0,
    errors,
  };
}

/**
 * Helper to identify authentication callback and password recovery routes.
 */
export function isAuthCallbackRoute(pathname: string): boolean {
  return [
    "/reset-password",
    "/login-success",
    "/signup-success",
    "/auth/callback",
  ].includes(pathname);
}
